import "../../index23.css";
import { jsxs as p, jsx as n, Fragment as A } from "react/jsx-runtime";
import { useRef as f, useState as M, useEffect as E, useCallback as m, useMemo as F } from "react";
import { ArrowUpSmallFillIcon as W, ArrowDownSmallFillIcon as j } from "@ifrc-go/icons";
import { _ as u } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import q from "../Button/index.js";
import U from "../Popup/index.js";
import z from "../../contexts/dropdown-menu.js";
import G from "../../hooks/useBlurEffect.js";
const H = "_dropdown-icon_1lvgq_10", J = "_dropdown-content_1lvgq_16", a = {
  dropdownIcon: H,
  dropdownContent: J
};
function eo(w) {
  const h = f(null), {
    className: C,
    activeClassName: b,
    children: R,
    label: _,
    labelBefore: g,
    labelAfter: s,
    labelSpacing: v,
    labelColorVariant: I,
    labelStyleVariant: N,
    labelWithoutPadding: D,
    withoutDropdownIcon: c,
    componentRef: t,
    elementRef: r = h,
    persistent: d,
    popupClassName: S,
    preferredPopupWidth: x
  } = w, i = f(null), [e, o] = M(!1);
  E(() => {
    t && (t.current = {
      setShowDropdown: o
    });
  }, [t, o]);
  const B = m(
    () => {
      o((l) => !l);
    },
    [o]
  ), P = m(
    (l, y) => {
      y || l && d || o(!1);
    },
    [o, d]
  );
  G(
    e,
    P,
    i,
    r
  );
  const V = F(
    () => ({
      setShowDropdown: o
    }),
    [o]
  ), k = !!s || !c;
  return /* @__PURE__ */ p(z.Provider, { value: V, children: [
    /* @__PURE__ */ n(
      q,
      {
        name: void 0,
        className: u(
          e && b,
          C
        ),
        layoutElementRef: r,
        onClick: B,
        styleVariant: N,
        colorVariant: I,
        withoutPadding: D,
        spacing: v,
        after: k ? /* @__PURE__ */ p(A, { children: [
          s,
          !c && (e ? /* @__PURE__ */ n(W, { className: a.dropdownIcon }) : /* @__PURE__ */ n(j, { className: a.dropdownIcon }))
        ] }) : void 0,
        before: g,
        children: _
      }
    ),
    e && /* @__PURE__ */ n(
      U,
      {
        elementRef: i,
        className: u(a.dropdownContent, S),
        parentRef: r,
        preferredWidth: x,
        children: R
      }
    )
  ] });
}
export {
  eo as default
};
